import React from 'react';
import {Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";

const ServicerDetailTable = ({ classes, servicerData}) => (
    <Table className={classes.table} size="small">
        <TableHead>
            <TableRow>
                <TableCell variant="head">Name</TableCell>
                <TableCell variant="head">Email</TableCell>
                <TableCell variant="head">Phone</TableCell>
                <TableCell variant="head">Website</TableCell>
                <TableCell variant="head">Choice Of Law</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            <TableRow>
                <TableCell variant="body">{servicerData.name || 'N/A'}</TableCell>
                <TableCell variant="body">{servicerData.email || 'N/A'}</TableCell>
                <TableCell variant="body">{servicerData.phone || 'N/A'}</TableCell>
                <TableCell variant="body">{servicerData.website || 'N/A'}</TableCell>
                <TableCell variant="body">{servicerData.choiceOfLaw}</TableCell>
            </TableRow>
        </TableBody>
    </Table>
);

export default ServicerDetailTable;
